import { ClueSolvingSubBehaviour } from "../../ClueSolvingSubBehaviour";
import { Clues } from "../../../model/Clues";
import { Scans } from "../../../cluetheory/Scans";
import { deps } from "../../../dependencies";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
import { TileCoordinates, TileRectangle } from "../../../../lib/runescape/coordinates";
import { ScanMinimapOverlay } from "./ScanMinimapOverlay";
import { GameLayer } from "../../../../lib/gamemap/GameLayer";
import { ScanEditLayer } from "../../../ui/theorycrafting/scanedit/ScanEditor";
var digSpotArea = Clues.digSpotArea;
import { MinimapReader } from "../../../../lib/alt1/readers/MinimapReader";
import { ScanCaptureService, ScanPanelOverlay } from "./ScanPanelReader";
export class SimpleScanSolving extends ClueSolvingSubBehaviour {
    constructor(parent, clue, original_interface_capture) {
        super("SimpleScan", parent, "clue");
        this.clue = clue;
        this.original_interface_capture = original_interface_capture;
        this.selected_solution = null;
        this.handling_layer = null;
        this.settings = deps().app.settings.settings.solving.scans;
        if (this.original_interface_capture) {
            this.minimap_overlay = this.withSub(new ScanMinimapOverlay(MinimapReader.instance(), parent.app.settings.observable_settings.map(s => s.solving.scans).structuralEquality(), "manual").setRange(Scans.range(clue, this.original_interface_capture.hasMeerkats())));
        }
        this.scan_panel_capture_service = new ScanCaptureService(this.original_interface_capture);
        this.scan_panel_overlay = this.withSub(new ScanPanelOverlay().connect(this.scan_panel_capture_service));
        this.scan_panel_overlay.enabled.bindTo(this.parent.app.settings.observable_settings.map(s => s.solving.scans.panel_status_overlay_enabled, this.lifetime_manager));
    }
    begin() {
        this.registerSolution(TileArea.fromRect(TileRectangle.extend(TileRectangle.from(...this.clue.spots), 1)));
        const self = this;
        this.parent.map_layer.scan_layer.marker.add(new class extends GameLayer {
            eventClick(event) {
                event.onPre(() => {
                    if (event.active_entity instanceof ScanEditLayer.SpotMarker) {
                        event.stopAllPropagation();
                        if (TileCoordinates.equals(self.selected_solution, event.active_entity.spot)) {
                            self.selected_solution = null;
                            self.parent.map_layer.scan_layer.setActiveCandidates(self.clue.spots);
                            self.registerSolution(TileArea.fromRect(TileRectangle.extend(TileRectangle.from(...self.clue.spots), 1)));
                        }
                        else {
                            self.selected_solution = event.active_entity.spot;
                            self.parent.map_layer.scan_layer.setActiveCandidates([event.active_entity.spot]);
                            self.registerSolution(digSpotArea(event.active_entity.spot));
                        }
                    }
                });
            }
        });
    }
    end() {
        this.handling_layer?.remove();
    }
}
